import { render, staticRenderFns } from "./FormsView.vue?vue&type=template&id=9d71fe10&scoped=true&"
import script from "./FormsView.vue?vue&type=script&lang=js&"
export * from "./FormsView.vue?vue&type=script&lang=js&"
import style0 from "./FormsView.vue?vue&type=style&index=0&id=9d71fe10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d71fe10",
  null
  
)

export default component.exports